import { FullPriceWithDiscount } from "@/components/PriceWithDiscount.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import type { Price } from "@/modules/pricing/resourcePricing.ts";
import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";

interface MonthlyCostRowProps {
    price: Price;
    tooltip?: string;
    children?: ReactNode;
    billingAccountId?: number;
}

export function MonthlyCostRow({ tooltip, children, ...priceProps }: MonthlyCostRowProps) {
    const { t } = useLingui();
    return (
        <DetailsTableRow tooltip={tooltip} title={t`Est. monthly cost`}>
            {children ? (
                children
            ) : (
                <b>
                    <FullPriceWithDiscount {...priceProps} showDiscount allowFree />
                </b>
            )}
        </DetailsTableRow>
    );
}
